module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-12-6efdffa229eafd43fbb951ad67d3a46c.jpg";